<template>
  <div class="grid-view">
    <div class="main-content">
      <search-bar ref="searchBar" :type-list="typeList" :show-refresh="false" :show-input-val="false" :ocr-tab="OCR_TAB_IDENTIFY.code" :source="source" @change="searchChange" />
      <div
        style="height: 100%;justify-content: space-between;display: flex;border:1px solid #BDC3C7;"
        @click="triggerUpload"
      >
        <div class="drop-uploader-icon" style="width:100%;text-align: center;">
          <div>
            <i class="el-icon-upload" />
          </div>
          <div>
            <p style="font-size: 20px; color: #2d2f33">
              {{ $t('CargoMsg.Cargo_Will') }}
              <span style="font-size: 20px; font-weight: bold">{{ fileTypeText }}</span>
              {{ $t('CargoMsg.Cargo_DFI') }}
              <span style="font-size: 20px; color: blue">{{ $t('Message.ClickUpload') }}</span>
            </p>
            <p style="font-size: 14px; color: #2d2f33">{{ $t('SeaExport.SupportUploadFormat') }}pdf/xls/xlsx/doc/docx/jpg/gif/png</p>
          </div>
        </div>
        <div class="watermark">
          <div v-for="(item, index) in watermarkTexts" :key="index" class="watermark-text">{{ item }}</div>
        </div>
      </div>
      <drop-uploader
        ref="dropUploader"
        :action="URL.AIdiscern.importAndAnalyseFile"
        :upload-params="{ source: source, iChannel: String(iChannel), jobUuid: jobUuid, docUuid: docUuid, pageSource: 'ocr', officeId: $store.getters.currentOfficeId }"
        :accept="['pdf','xls','xlsx','doc','docx','jpg','gif','png','msword', 'ms-excel', 'jpeg']"
        :bs-open="bsOpen"
        :open-drag="openDrag && bsOpen"
        :channel-open="channelOpen"
        :bs-remaining-amount-enough="bsRemainingAmountEnough"
        :file-format="fileFormat"
        @upload-end="uploadEnd"
      />
    </div>
  </div>
</template>

<script>
import IntelligentBookingTable from '@/views/cargo/v0/ToolAssistant/ocr/components/IntelligentBookingTable'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import URL from '@/api/urlTranslator'
import SearchBar from '@/views/cargo/v0/ToolAssistant/ocr/components/SearchBar'
import {
  SENDING_2,
  SENDING_0,
  OCR_TAB_IDENTIFY,
  BS_ITEM_MAP,
  SENDING_1,
  IDENTIFICATION_TYPE_DEFAULT,
  SENDING_4,
  SENDING_5,
  INTELLIGENT_DOCUMENT_SOURCE_11
} from '@/class/cargo/model/parameters/SystemConstants'
import { checkBsItemOpened } from '@/api/booking/job'
import OcrUtils from '@/utils/OcrUtils'
import { getChannelConfigUrlFunc } from '@/api/seaExport/intelligentBooking'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'TabOcr',
  components: { SearchBar, DropUploader, IntelligentBookingTable },
  props: {
    activeTabName: {
      type: String,
      default: () => ''
    }, openDrag: {
      type: Boolean,
      default: () => true
    },
    jobUuid: {
      type: String,
      default: () => ''
    },
    docUuid: {
      type: String,
      default: () => ''
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => INTELLIGENT_DOCUMENT_SOURCE_11.code
    }
  },
  data() {
    return {
      URL,
      fileFormat: null,
      loading: false,
      iChannel: 0,
      fileTypeText: this.$t('CargoMsg.Cargo_seaFile'),
      showType: 1,
      SENDING_2,
      SENDING_0,
      codeBsMap: {}, // 计费项是否开通
      bsOpen: false,
      channelOpen: false,
      channelConfig: null,
      bsRemainingAmountEnough: false, // 余额充足
      watermarkTexts: Array(200).fill('OCEAN EXPORT SHIPPING ORDER'),
      OCR_TAB_IDENTIFY,
      typeList: IDENTIFICATION_TYPE_DEFAULT
    }
  },
  watch: {
    activeTabName(val, oldVal) {
      this.positionWatermarks()
    }
  },
  mounted() {
    this.positionWatermarks()
    window.addEventListener('resize', this.positionWatermarks)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.positionWatermarks)
  },
  methods: {
    init() {
      const { typeList, recognitionType } = OcrUtils.getIdentificationTypes(this.source)
      this.typeList = typeList
      this.$nextTick(() => {
        this.$refs.searchBar.searchConditions.identificationType = recognitionType
        this.textChange(recognitionType)
      })
    },
    async queryBs() {
      // 查询计费系统是否开通托书
      console.log('this.iChannel ', this.iChannel)
      console.log('BS_ITEM_MAP.get(this.iChannel)', BS_ITEM_MAP.get(this.iChannel))
      console.log('BS_ITEM_MAP', BS_ITEM_MAP)
      const loading = getLoading4Cxt()
      const key = BS_ITEM_MAP.get(this.iChannel)
      let keyMap = this.codeBsMap[key]
      if (keyMap) {
        this.bsOpen = keyMap['bsOpen']
        this.bsRemainingAmountEnough = keyMap['bsRemainingAmountEnough']
        loading.close()
      } else {
        keyMap = {}
        await checkBsItemOpened(BS_ITEM_MAP.get(this.iChannel)).then(res => {
          if (!res.data || res.data === -1) {
            this.bsOpen = false // 点击是否提示计费未开通 false 未开通
            keyMap['bsOpen'] = false
          } else if (res.data === -2) {
            this.bsOpen = true
            this.bsRemainingAmountEnough = false
            keyMap['bsOpen'] = true
            keyMap['bsRemainingAmountEnough'] = false
          } else {
            this.bsOpen = true
            this.bsRemainingAmountEnough = true
            keyMap['bsOpen'] = true
            keyMap['bsRemainingAmountEnough'] = true
          }
          this.codeBsMap[key] = keyMap
          loading.close()
        })
      }
      await getChannelConfigUrlFunc().then(res => {
        this.channelConfig = res.data
        this.getChannelConfig(this.iChannel)
      })
    },
    getChannelConfig(val) {
      if (!this.channelConfig) {
        this.channelOpen = false
      } else {
        this.channelOpen = false
        // 海出托书
        if ([SENDING_1.code, SENDING_2.code].includes(val) && this.channelConfig.tdChannel) {
          this.channelOpen = true
        } else if (val === SENDING_0.code && this.channelConfig.tsChannel) {
          this.channelOpen = true
        } else if ([SENDING_4.code, SENDING_5.code].includes(val)) {
          this.channelOpen = true
        }
      }
    },
    positionWatermarks() {
      const watermarkContainer = document.querySelector('.watermark')
      const watermarkTexts = watermarkContainer.querySelectorAll('.watermark-text')
      const containerWidth = window.innerWidth // 使用窗口宽度作为容器宽度
      const containerHeight = window.innerHeight // 使用窗口高度作为容器高度
      const textWidth = watermarkTexts[0].offsetWidth
      const textHeight = watermarkTexts[0].offsetHeight
      const columns = Math.ceil(containerWidth / (textWidth + 180)) // 调整左右间隔
      const rows = Math.ceil(containerHeight / (textHeight + 20)) // 调整上下间隔

      watermarkContainer.style.width = `${columns * (textWidth + 180)}px` // 设置容器宽度
      watermarkContainer.style.height = `${rows * (textHeight + 20)}px` // 设置容器高度

      watermarkTexts.forEach((text, index) => {
        const column = index % columns
        const row = Math.floor(index / columns)
        const left = column * (textWidth + 280) // 调整左右间隔
        const top = row * (textHeight + 40) // 调整上下间隔
        text.style.left = `${left}px`
        text.style.top = `${top}px`

        text.style.transform = 'rotate(-45deg)' // 旋转-45度
        text.style.transformOrigin = 'left top' // 设置旋转的中心点为左上角
      })
    },
    triggerUpload() {
      if (!this.channelOpen) {
        this.$message.warning(this.$t('CargoMsg.Cargo_IdentificationCannotBePerformedTip'))
        return
      }
      if (!this.bsOpen) {
        this.$message.warning(this.$t('CargoMsg.Cargo_UnopenedService'))
      } else if (!this.bsRemainingAmountEnough) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RemainingAmountNotEnough'))
      } else {
        this.$refs.dropUploader.triggeFileSelectWindow()
      }
    },
    uploadEnd(e) {
      this.$emit('uploadEnd')
    },
    searchChange(e) {
      if (e.type === 'select') {
        this.textChange(e.value)
      }
    },
    async textChange(value) {
      this.iChannel = value
      await this.queryBs()
      if (value === SENDING_0.code) {
        this.watermarkTexts = Array(200).fill(this.$t('CargoMsg.Cargo_seaFile2'))
        this.fileTypeText = this.$t('CargoMsg.Cargo_seaFile')
      } else if (value === SENDING_1.code) {
        this.watermarkTexts = Array(200).fill(this.$t('CargoMsg.Cargo_siFile2'))
        this.fileTypeText = this.$t('CargoMsg.Cargo_siFile')
      } else if (value === SENDING_2.code) {
        this.watermarkTexts = Array(200).fill(this.$t('CargoMsg.Cargo_seBillFile2'))
        this.fileTypeText = this.$t('CargoMsg.Cargo_seBillFile')
      } else if (value === SENDING_4.code) {
        this.watermarkTexts = Array(200).fill(this.$t('CargoMsg.Cargo_aeFile2'))
        this.fileTypeText = this.$t('CargoMsg.Cargo_aeFile')
      } else if (value === SENDING_5.code) {
        this.watermarkTexts = Array(200).fill(this.$t('CargoMsg.Cargo_aiFile2'))
        this.fileTypeText = this.$t('CargoMsg.Cargo_aiFile')
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss">
.drop-uploader {
  position: relative;
  height:100%;
  z-index: 9999;
  .el-upload {
    width: 100%;
    height: 100%;
    &-dragger {
      width: 100%;
      height: 100%;
      background-color: transparent;
      &.is-dragover{
        background-color: rgba(24, 144, 225,.1);
        .drop-uploader-icon {
          color: #1890ff;
          .el-icon-upload{
            color: #1890ff;
          }
        }
      }
    }
  }
  &-icon {
    display: inline-block;
    position: absolute;
    top:40.5%;
    left: 49%;
    transform: translate(-50%,-50%);
    font-size: 48px;
    color:#C0C4CC;
    .el-icon-upload {
      font-size: 200px;
    }
  }
}

.watermark {
  position: fixed;
  width: 100%;
  height: 100%;
  //z-index: -1;
  pointer-events: none;
  overflow: hidden; /* 隐藏超出容器的水印文字 */
}

.watermark-text {
  top: 0;
  left: 0;
  transform: rotate(-145deg); /* 将文字旋转为斜着显示 */
  position: absolute;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.2); /* 设置文字颜色和透明度 */
  font-weight: bold;
  text-transform: uppercase;
  writing-mode: vertical-rl; /* 设置文字方向为垂直 */
  white-space: nowrap; /* 防止文字换行 */
}
</style>
